<template>
  <div class="demo-spin-article">
    <div class="ls_action_header">
      <Row class="ls_action_header header-flex mb-30" style="padding-top: 6px" type="flex" justify="space-between">


        <!-- TEXT SEARCH -->
        <Row type="flex" :gutter="24" class="header-flex__left">

          <Col :xs="24" :sm="24" :md="24" :lg="0" class="mb-10">
            <Input
              placeholder="Введите наименование/артикул/код"
              class="search-input"
              v-model="searchString"
            >
              <Icon type="ios-search" slot="suffix" />
            </Input>
          </Col>


          <Col :xs="24" :sm="12" :md="12" :lg="0" class="mb-10">
            <Button
              style="width: 100%;"
              type="primary"
              class="ls_bulk_delete_button font-bold"
              @click="showGroupModal=true"
            >
              {{ groupButtonName }}
              <Icon type="ios-arrow-down" />
            </Button>
            <Modal
              v-model="showGroupModal"
              @on-cancel=""
              title="Выберите группу товаров"
            >
              <!--<div style="margin-top: 25px;">-->
              <!--<Input search placeholder="Введите название группы" />-->
              <Tree
                :data="groupData"
                :load-data="fetchChildrenGroups"
                @on-select-change="selectGroup"
              ></Tree>
              <!--</div>-->
              <div slot="footer">
                <Button  type="error" size="large" @click="showGroupModal=false">Отменить</Button>
              </div>
            </Modal>
          </Col>


          <Col :xs="24" :sm="12" :md="12" :lg="0" class="mb-10">
            <Select
              class="br-18"
              v-model="filter.type"
              style="width:100%; margin-right: 24px"
              clearable
              placeholder="Тип"
            ><Option
              v-for="item in filterOptions.type"
              :value="item.value"
              :key="item.value"
            >{{ item.label }}</Option
            >
            </Select>
          </Col>











<!--          <Select-->
<!--                  v-model="filter.store"-->
<!--                  style="width:150px; text-align: left"-->
<!--                  clearable-->
<!--                  placeholder="Магазин"-->
<!--          ><Option-->
<!--                  v-for="item in filterOptions.store"-->
<!--                  :value="item.id"-->
<!--                  :key="item.id"-->
<!--          >{{ item.name }}</Option></Select>-->




          <!--<FormItem label="Switch">-->


          <!--<Button v-if="showClearFilter" type="text" @click="clearFilter"-->
            <!--&gt;Сбросить фильтр</Button-->
          <!--&gt;-->

        </Row>
        <!-- CREATE -->
        <Col style="text-align: right">
          <Button
            v-if="display_create_button"
            type="info"
            class=""
            style="margin-right: 24px"
            :to="{ name: 'catalog_import' }"
          ><span class="d-flex align-center">
            Импорт
            <img src="/static/svg/import.svg" alt="">
          </span>
          </Button>

          <Button
            v-if="display_create_button"
            type="primary"
            class=""
            :to="{ name: item_type + '_create' }"
          ><span class="d-flex align-center">
            Создать
            <img src="/static/svg/create.svg" alt="">
          </span>
          </Button>

          <!--<Row>-->
            <!--<Col span="12">-->
              <!--<Button-->
                <!--v-if="display_create_button"-->
                <!--type="info"-->
                <!--class=""-->
                <!--:to="{ name: 'catalog_import' }"-->
              <!--&gt;Импорт-->
              <!--</Button>-->
            <!--</Col>-->
            <!--&lt;!&ndash; CREATE &ndash;&gt;-->
            <!--<Col span="12">-->
              <!--<Button-->
                <!--v-if="display_create_button"-->
                <!--type="success"-->
                <!--class=""-->
                <!--:to="{ name: item_type + '_create' }"-->
                <!--&gt;Создать-->
              <!--</Button>-->
            <!--</Col>-->
          <!--</Row>-->
        </Col>
      </Row>

      <Row class="mb-15" type="flex" justify="space-between">

        <!-- BULK DELETE -->
        <Col>
          <!-- BULK ACTIONS-->
          <Button
            v-if="selected.length != 0"
            type="error"
            class="ls_bulk_delete_button"
            @click="bulkDelete"
          >Удалить
          </Button>
          <div v-else style="padding: 1px"></div>
        </Col>

        <Col>
          <Button v-if="showClearFilter"
                  @click="clearFilter"
                  type="error"
          >Сбросить фильтр</Button>
        </Col>

      </Row>



      <Row :gutter="10" type="flex" justify="center" v-show="filterShow" style="margin-bottom: 24px">

      </Row>
    </div>
    <!-- DATA TABLE  -->

    <Table
      class="desktop_table"
      :loading="loading"
      :columns="columns"
      :data="data"
      @on-sort-change="changeSorting"
      @on-selection-change="onSelectChange"
    ></Table>


    <!-- DATA MOBILE TABLE -->
    <div class="mobile-table">

      <router-link :to="item_type + '/detail/' + item.id" v-for="item in data" class="card-container">
        <div>
          <h2>{{item.name}}</h2>
          <p>Код: {{item.barcode}}</p>
          <p>Артикул: {{item.sku}}</p>
          <p>Ед.изм.: {{item.unit}}</p>
          <p>Скидка: {{item.discount}} %</p>
        </div>

        <div>
          <p class="price">{{item.base_price}} {{currency}}</p>
        </div>
        <div>
          <p class="price">{{item.trade_price}} {{currency}}</p>
        </div>

      </router-link>
    </div>

    <!--  PAGINATION -->
    <Page
      :total="totalRecords"
      :page-size="pageSize"
      :page-size-opts="[15, 25, 35]"
      @on-change="changePage"
      @on-page-size-change="changePageSize"
      show-sizer
      :styles="{ marginTop: '30px', float: 'right' }"
    />


    <!-- ITEM VIEW -->
    <catalogItem
      :id="item.id"
      :action="item.action"
      v-model="item.show"
      @reload-table="fetchItems"
      :base_view_url="baseViewUrl"
      :item_type="item_type"
    ></catalogItem>



    <!--Modal for remove Item-->
    <Modal
      :footer-hide="footerHide"
      v-model="removeModal"
      title="">

      <h3 class="mb-40">Вы действительно хотите удалить данный <span class="no-wrap">товар/услугу</span>?</h3>

      <Row type="flex" justify="center">
        <Button type="error" @click="removeModal = false">Отмена</Button>
        <Button type="success" style="margin-left: 12px"
                @click="deleteItem(removeId)">
          Удалить
        </Button>
      </Row>
    </Modal>


  </div>
</template>
<script>
import { base_url } from "../../http.js";
import { formatNumber } from "../../base/base_func.js";
import { BaseTableData } from "../../base/base_table.js";
import catalogItem from "@/apps/catalog/catalogItem.vue";

let _app = BaseTableData();
_app.components = {
  catalogItem
};

_app.data = function() {
  return {
    // Base settings
    baseViewUrl: base_url + "/catalog/products/",
    item_type: "catalog",
    loading: true,

      removeModal: false,
      removeId: null,
      footerHide: true,

    //currency: localStorage.getItem('currency'),

    // Table settings
    columns: [
      {
        type: "selection",
        width: 40,
        align: "center",
      },
      {
        title: "Наименование",
        maxWidth: 400,
        key: "name",
        render: (h, params) => {
          return h(
            "router-link",
            {
              props: {
                to: {
                  name: this.item_type + "_detail",
                  params: { id: params.row.id }
                }
              }
            },
            params.row.name
          );
        }
      },


      {
            title: "Код",
            // width: 150,
            // maxWidth: 140,
            key: "barcode",
            sortable: true,
            align: "center"
        },
        {
            title: "Артикул",
            // width: 150,
            // maxWidth: 140,
            key: "sku",
            sortable: true,
            align: "center"
        },
      {
          title: "Ед.изм.",
          // width: 60,
          key: "unit",
          // width: 100,
          align: "center"
      },
      // {
      //   title: "Оптовая цена",
      //   // width: 90,
      //   key: "trade_price",
      //   sortable: true,
      //   // width: 150,
      //   align: "center",
      //   render: (h, params) => {
      //     // return h("span", {}, formatNumber(params.row.purchase) + ' ' + this.currency);
      //       return h("span", {}, formatNumber(params.row.trade_price) + ' ' + this.currency);
      //   }
      // },
      {
        title: "Розничная цена",
        // width: 90,
        key: "base_price",
        sortable: true,
        // width: 150,
        align: "center",
        render: (h, params) => {
          // return h("span", {}, formatNumber(params.row.purchase) + ' ' + this.currency);
            return h("span", {}, formatNumber(params.row.base_price) + ' ' + this.currency);
        }
      },
      // {
      //   title: "Цена продажи за ед.",
      //   // width: 90,
      //   key: "base_price",
      //   sortable: true,
      //   // width: 150,
      //   align: "right",
      //   render: (h, params) => {
      //     return h("span", {}, formatNumber(params.row.base_price) + ' ' + this.currency);
      //   }
      // },
      {
        title: "Скидка",
        // width: 100,
        key: "discount",
        sortable: true,
        align: "center",
        render: (h, params) => {
          return h("span", {}, params.row.discount + ' %');
        }
      },
      {
        title: " ",
        // key: 'action',
        width: 120,
        align: "right",
        render: (h, params) => {
          let buttons = [];
          if (this.display_edit_button_by_row(params.row)) {
            buttons.push(
              h(
                "Tooltip",
                {
                  props: {
                    content: "Редактировать"
                  }
                },
                [
                  h("Button", {
                    props: {
                      to: {
                        name: this.item_type + "_edit",
                        params: { id: params.row.id }
                      },
                      type: "primary",
                      size: "small",
                      // icon: 'ios-information-circle-outline',
                      icon: "md-create",
                    },
                    style: {
                        display: "flex", alignItems: "center", boxShadow: "none", background: "transparent", border: "none", color: "#DEDEDE",
                    },

                  })
                ]
              ),
            );
          }
          if (this.display_delete_button_by_row(params.row)) {
            buttons.push(
              h(
                "Tooltip",
                {
                  props: {
                    content: "Удалить"
                  }
                },
                [
                  h("Button", {
                    props: {
                      size: "small",
                      icon: "md-trash",
                    },
                    on: {
                      click: () => {
                          this.removeModal = true;
                          this.removeId = params.row.id;
                      }
                    },
                      style: {
                          display: "flex", alignItems: "center", boxShadow: "none", background: "transparent", border: "none", color: "#DEDEDE",
                      }
                  })
                ]
              )
            );
          }

          return h("div", buttons);
        }
      }
    ],
    data: [],
    lastDraw: 0,
    totalRecords: null,
    currentPage: 1,
    pageSize: 15,
    sorting: "",
    searchString: "",
    // showClearFilter: false,

    filterShow: false,
    filter: {
      type: "",
      // store: ""
      // applied: "",
      // order_date__gt: "",
      // order_date__lt: "",
      group: ""
    },
    filterOptions: {
      type: [
        {
          value: "PRODUCT",
          label: "Продукт"
        },
        {
          value: "SERVICE",
          label: "Услуга"
        },
        {
          value: "KIT",
          label: "Комплект"
        }
      ],
      // store: []
      // applied: [
      //   {
      //     value: "true",
      //     label: "Проведен"
      //   },
      //   {
      //     value: "false",
      //     label: "Не проведен"
      //   }
      // ],
    },

    filterOrderDate: ["", ""],
    selected: [],

    item: {
      show: false,
      id: null,
      action: null
    },

    loadedGroups: false,
    showGroupModal: false,
    groupData: [],
    selectedGroupName: ""
  };
};

_app.computed.groupButtonName = function(){
  return (this.selectedGroupName&&this.filter.group) ? this.selectedGroupName : "Выбрать группу";
};
// _app.computed.display_edit_button = function() {
//   return (
//     this.permissions.indexOf("catalog.product_update_all") !== -1 ||
//     this.permissions.indexOf("catalog.product_update_owner") !== -1
//   );
// };
_app.computed.display_delete_button = function() {
  return (
    this.permissions.indexOf("catalog.product_delete_all") !== -1 ||
    this.permissions.indexOf("catalog.product_delete_owner") !== -1
  );
};
_app.computed.display_create_button = function() {
  return (
    this.permissions.indexOf("catalog.product_create") !== -1
  );
};

_app.methods.display_edit_button_by_row = function(row) {
  if ('can_update' in row) {
    return (row.can_update && (
      this.permissions.indexOf("catalog.product_update_all") !== -1 ||
      this.permissions.indexOf("catalog.product_update_owner") !== -1
    ));
  }
  return (
    this.permissions.indexOf("catalog.product_update_all") !== -1 ||
    this.permissions.indexOf("catalog.product_update_owner") !== -1
  );
};

_app.methods.display_delete_button_by_row = function(row) {
  if ('can_delete' in row) {
    return (row.can_delete && (
      this.permissions.indexOf("catalog.product_delete_all") !== -1 ||
      this.permissions.indexOf("catalog.product_delete_owner") !== -1
    ));
  }
  return (
    this.permissions.indexOf("catalog.product_delete_all") !== -1 ||
    this.permissions.indexOf("catalog.product_delete_owner") !== -1
  );
};


// Переключения режима "Доп.фильтр"
_app.methods.toogleFilter = function(val) {
  this.filterShow = val;

  // Если убираем фильтр - очищаем все поля фильтра
  if (!val) {
    for (let key in this.filter) {
      this.filter[key] = "";
    }

    // Дополнительная очистка фильтров (Даты документа)
    this.filterOrderDate = [];
  }
};

// Очистка фильтров
_app.methods.clearFilter = function() {
  // Очистка общих фильтров и посика
  if (this.searchString) {
    this.searchString = "";
  }
  for (let key in this.filter) {
    if (this.filter[key]) {
      this.filter[key] = "";
    }
  }

  // Дополнительная очистка фильтров (Даты документа)
  this.filterOrderDate = [];

  // Перезагрузка групп
  this.loadedGroups = false;
};

_app.methods.changeFilterOrderDate = function(date_arr, date_obj) {
  if (date_arr[0] && date_arr[1]) {
    this.filter.order_date__gt = this.filterOrderDate[0];
    this.filter.order_date__lt = this.filterOrderDate[1];

    // this.filter.order_date__gt = date_arr[0] + 'T00:00:00';
    // this.filter.order_date__lt = date_arr[1] + 'T00:00:00';
  }
};

// Очистка полей поиска даты документа (Order date), после чего срабатывает watcher и обновляются данные в таблице
_app.methods.clearFilterOrderDate = function(date_arr, date_obj) {
  this.filter.order_date__gt = "";
  this.filter.order_date__lt = "";
};

_app.methods.fetchGroups = function() {
  const url = base_url + "/catalog/groups/?parent=true";
  this.$http
    .get(url)
    .then(result => {
      if (result.data.results) {
        this.groupData = [];
        for (const item of result.data.results) {
          let item_data = {
              id: item.id,
              title: item.name,
              // loading: false,
          };
          if (item.has_children) {
            item_data.children = [];
            item_data.loading = false;
          }
          this.groupData.push(item_data);
        }
        this.loadedGroups = true;
      }
    })
};

_app.methods.fetchChildrenGroups = function (item, callback){
  const url = base_url + `/catalog/groups/${item.id}/children/`;
  this.$http
    .get(url)
    .then(result => {
      if (result.data.results) {
        let data = [];
        for (const item of result.data.results) {
          let item_data = {
            id: item.id,
            title: item.name,
          };
          if (item.has_children) {
            item_data.children = [];
            item_data.loading = false;
          }
          data.push(item_data);
        }
        callback(data);
      }
    })
};

_app.methods.selectGroup = function (item, callback){
  this.showGroupModal = false;
  this.filter.group = item[0].id;
  this.selectedGroupName = item[0].title;
};

// _app.methods.getStores = function() {
//   const url = base_url + "/options/stores/";
//   this.$http
//           .get(url)
//           .then(result => {
//             this.filterOptions.store = result.data.results;
//           })
//           .catch(error => {
//             this.$Message.error("Произошла ошибка");
//           });
// };
//
// _app.created = function() {
//   this.getStores();
// };

_app.watch['showGroupModal'] = function() {
  if (!this.loadedGroups) this.fetchGroups();
};

// _app.methods.showCategoryModal = function() {
//   const title = 'Title';
//   const content = '<p>Content of dialog</p><p>Content of dialog</p>';
//       this.$Modal.info({
//         title: title,
//         content: content
//       });
// };
export default _app;
</script>


<style>

  .ls_bulk_delete_button span {
    display: flex;
    justify-content: space-between;
  }

  ul.ivu-tree-children .ivu-tree-title{
    font-size: 16px;
    font-weight: bold;
  }

  .search-input {
    width: 400px;
  }
  @media screen and (max-width: 1900px) {
    .search-input {
      width: 380px;
    }
  }

  @media screen and (max-width: 1500px) {
    .search-input {
      width: 340px;
    }
  }

  @media screen and (max-width: 991px) {
    .header-flex__left {
      width: calc(100% + 24px);
    }
    .search-input {
      width: 100%;
    }
  }

  @media (min-width: 992px) {
    .ivu-col-span-lg-0 {
      display: block;
      width: auto;
    }

  }


</style>



// WEBPACK FOOTER //
// src/apps/catalog/catalog.vue